import { render, staticRenderFns } from "./ScreenViloCorial.vue?vue&type=template&id=b9142df0&scoped=true&"
import script from "./ScreenViloCorial.vue?vue&type=script&lang=js&"
export * from "./ScreenViloCorial.vue?vue&type=script&lang=js&"
import style0 from "./ScreenViloCorial.vue?vue&type=style&index=0&id=b9142df0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9142df0",
  null
  
)

export default component.exports